

  <!--==========================
    Intro Section
  ============================-->
  <section id="intro" class="clearfix">
    <div class="container">

      <div class="intro-img">
        <img src="../assets/img/intro-img.svg" alt="" class="img-fluid">
      </div>

      <div class="intro-info">
        <h2>We provide<br><span>technology</span><br>for your business!</h2>
        <div>
          <a [routerLink]="['/about-us']" class="btn-get-started scrollto">Get Started</a>
          <a [routerLink]="['/services']" class="btn-services scrollto">Our Services</a>
        </div>
      </div>

    </div>
  </section><!-- #intro -->
  <main id="main">

   

   

    <!--==========================
      Why Us Section
    ============================-->
    <section id="why-us" class="wow fadeIn">
      <div class="container">
        <header  class="section-header" style=" margin-bottom: 80px;">

          <h1 style="text-align: center;background: #1845a9;color: white;width: max-content;display: table;margin: auto;padding: 10px;padding-left: 20px;padding-right: 20px;border-radius: 20px;cursor: pointer;">A certified <span style="font-weight: bold;">Recurly</span> integrator</h1>
          </header>
        <header class="section-header">
          <h1 style="text-align: center;">Why choose us?</h1>
         
        </header>

        <div class="row row-eq-height justify-content-center">

          <div class="col-lg-4 mb-4">
            <div class="card wow bounceInUp">
                <i class="fa fa-diamond"></i>
              <div class="card-body">
                <h5 class="card-title">Our Experience</h5>
                <p class="card-text">We have been working since 1992 in the application development business. We love discussing and planning new projects and have years of knowledge and experience that we bring to the table.</p>
               
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4">
            <div class="card wow bounceInUp">
                <i class="fa fa-money"></i>
              <div class="card-body">
                <h5 class="card-title">Cost-effective</h5>
                <p class="card-text">We provide cost-effective solutions to our clients based 
                  on business requirements and budget. We work with you to develop cost effective solutions.</p>
               
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4">
            <div class="card wow bounceInUp">
                <i class="fa fa-users"></i>
              <div class="card-body">
                <h5 class="card-title">Our Team</h5>
                <p class="card-text">We have our own in-house talented team with great skills in mobile app 
                  development, web application development and software product engineering.</p>
                
              </div>
            </div>
          </div>

        </div>

        <div class="row counters">

          <div class="col-lg-3 col-6 text-center">
            <span data-toggle="counter-up">729</span>
            <p>Clients</p>
          </div>

          <div class="col-lg-3 col-6 text-center">
            <span data-toggle="counter-up">52</span>
            <p>Projects</p>
          </div>

          <div class="col-lg-3 col-6 text-center">
            <span data-toggle="counter-up">420,500</span>
            <p>Hours Of Support</p>
          </div>

          <div class="col-lg-3 col-6 text-center">
            <span data-toggle="counter-up">27</span>
            <p>Years in operation</p>
          </div>
  
        </div>

      </div>
    </section>

   

    <!--==========================
      Clients Section
    ============================-->
    <section id="clients" class="section-bg">

      <div class="container">

        <div class="section-header">
          <h3>Our CLients</h3>
       
        </div>

        <div class="row no-gutters clients-wrap clearfix wow fadeInUp">

          <div class="col">
            <div class="client-logo">
              <img src="../assets/img/clients/client-1.png" class="img-fluid" alt="" >
            </div>
          </div>
          
          <div class="col">
            <div class="client-logo">
              <img src="../assets/img/clients/client-2.png" class="img-fluid" alt="" >
            </div>
          </div>
        
          <div class="col">
            <div class="client-logo">
              <img src="../assets/img/clients/client-3.png" class="img-fluid" alt="" >
            </div>
          </div>
          
          <div class="col">
            <div class="client-logo">
              <img src="../assets/img/clients/client-4.png" class="img-fluid" alt="">
            </div>
          </div>
          
          <div class="col">
            <div class="client-logo">
              <img src="../assets/img/clients/client-5.png" class="img-fluid" alt="">
            </div>
          </div>
        
          <div class="col">
            <div class="client-logo">
              <img src="../assets/img/clients/client-6.png" class="img-fluid" alt="">
            </div>
          </div>
          
         <!--  <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo">
              <img src="../assets/img/clients/client-7.png" class="img-fluid" alt="">
            </div>
          </div>
          
          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo">
              <img src="../assets/img/clients/client-8.png" class="img-fluid" alt="">
            </div>
          </div> -->

        </div>

      </div>

    </section>

    <section id="team">
        <div class="container">
          <div class="section-header">
            <h3>PLATFORMS, TECHNOLOGIES & LANGUAGES</h3>
            
          </div>
  
          <div class="row">
  
              <div class="row clients-wrap clearfix wow fadeInUp">

                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/aws.png" class="img-fluid" alt="" title="AWS">
                      <p>AWS</p>
                    </div>
                  </div>
                  
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/azure.png" class="img-fluid" alt="" title="MS Azure">
                      <p>MS Azure</p>
                    </div>
                  </div>

                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/angular.png" class="img-fluid" alt="" title="Angular">
                      <p>Angular</p>
                    </div>
                  </div>
                  
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/dotnet.png" class="img-fluid" alt="" title="MS.Net" >
                      <p>MS.Net</p>
                    </div>
                  </div>

                     
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/sql.png" class="img-fluid" alt="" title="MS Sql">
                      <p>MS Sql</p>
                    </div>
                  </div>

                     
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/pgsql.png" class="img-fluid" alt="" title="PostgreSql">
                      <p>PostgreSql</p>
                    </div>
                  </div>

                      
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/Apple.png" class="img-fluid" alt="" title="ios">
                      <p>ios</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/android.png" class="img-fluid" alt="" title="Android">
                      <p>Android</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/html5.png" class="img-fluid" alt="" title="HTML5">
                      <p>HTML5</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/xamarin.png" class="img-fluid" alt="" title="Xamarin" >
                      <p>Xamarin</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/nativescript.png" class="img-fluid" alt="" title="NativeScript" >
                      <p>NativeScript</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/php.png" class="img-fluid" alt="" title="PHP">
                      <p>PHP</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/nodejs.png" class="img-fluid" alt="" title="Node JS" >
                      <p>Node JS</p>
                    </div>
                  </div>
                  <div class="col">
                      <div class="tech">
                      <img src="../assets/img/tech/jquery.png" class="img-fluid" alt="" title="Jquery" >
                      <p>Jquery</p>
                    </div>
                  </div>
                </div>
          </div>
  
        </div>
      </section><!-- #team -->

  </main>


